import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
type Category = 'All' | 'Families' | 'Couples' | 'Newborns' | 'Portraits';
const images = [{
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/wD7Uw38YYjCv7LqMFwPhQJ/photos_by_tunga.jpg',
  category: 'Families',
  title: 'Beach Sunset'
}, {
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/w5rVbJj6XGTZQNgvM81Jxt/DSC_1198.jpg',
  category: 'Families',
  title: 'Christmas at the Park'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/5sjiQETaa7icZcAZsa4CsS/FullSizeRender_(8).jpg',
  category: 'Couples',
  title: 'Winter Kiss'
}, {
  id: 6,
  src: 'https://cdn.magicpatterns.com/uploads/rhiWdFYgSZyuj2SQjc98FB/574083030_836586222223814_9173835478495803776_n.jpg',
  category: 'Portraits',
  title: 'Capitol Portrait'
}, {
  id: 22,
  src: 'https://cdn.magicpatterns.com/uploads/pjxiexdFRfDpHQ8PpFncsy/IMG_4977.jpg',
  category: 'Couples',
  title: 'Sunset Silhouette'
}, {
  id: 27,
  src: 'https://cdn.magicpatterns.com/uploads/aCSyVQqKjztEprEi7QXexb/IMG_5297.jpg',
  category: 'Couples',
  title: 'Bridge Railing'
}, {
  id: 10,
  src: 'https://cdn.magicpatterns.com/uploads/3xKURqw44vEhvznMTCk36F/584060648_851265827422520_2323586727917488915_n.jpg',
  category: 'Couples',
  title: 'Christmas Couple'
}, {
  id: 23,
  src: 'https://cdn.magicpatterns.com/uploads/9uckQwPxc4CZnTM4jaXn76/IMG_5090.jpg',
  category: 'Couples',
  title: 'Piggyback Ride'
}, {
  id: 28,
  src: 'https://cdn.magicpatterns.com/uploads/hhdvHbHXUWS4srbNNBLcLu/IMG_5222.jpg',
  category: 'Couples',
  title: 'Bridge Overlook'
}, {
  id: 11,
  src: 'https://cdn.magicpatterns.com/uploads/wquGX1CPMZ6YMvpkWs3K88/IMG_1301.jpg',
  category: 'Couples',
  title: 'Snow Day'
}, {
  id: 12,
  src: 'https://cdn.magicpatterns.com/uploads/wDhnTUUkCTPyptCXVxaFro/573174977_18094296058813584_7879038735815211919_n.webp.jpg',
  category: 'Newborns',
  title: 'Mother & Newborn'
}, {
  id: 24,
  src: 'https://cdn.magicpatterns.com/uploads/5X7TMevX2eP6Hb6rpQK6yR/IMG_5132.jpg',
  category: 'Couples',
  title: 'Winter Gaze'
}, {
  id: 29,
  src: 'https://cdn.magicpatterns.com/uploads/vQu81gx1JpHXxKVBQyfvN5/IMG_4996.jpg',
  category: 'Couples',
  title: 'Snow Kiss'
}, {
  id: 13,
  src: 'https://cdn.magicpatterns.com/uploads/iYnB4S6bj87L7nyho4euPM/573389046_18094296094813584_1219373167929940024_n.webp.jpg',
  category: 'Newborns',
  title: 'New Sibling Love'
}, {
  id: 14,
  src: 'https://cdn.magicpatterns.com/uploads/wtKvEKncdNdk8uEmSVZznw/573609184_18094296121813584_3395720660765952247_n.webp.jpg',
  category: 'Newborns',
  title: 'Big Brother Kiss'
}, {
  id: 25,
  src: 'https://cdn.magicpatterns.com/uploads/cQ8KZRiUjrGmTYF8ejfkWU/IMG_5279.jpg',
  category: 'Couples',
  title: 'Golden Hour'
}, {
  id: 30,
  src: 'https://cdn.magicpatterns.com/uploads/iBR8Q4MqHsGDShrkyhpBoX/FullSizeRender_(2).jpg',
  category: 'Couples',
  title: 'Lakeside Embrace'
}, {
  id: 18,
  src: 'https://cdn.magicpatterns.com/uploads/hP2ztbeoPgKavn5JoBtHPN/568884403_833617409187362_7304931237899390213_n.jpg',
  category: 'Families',
  title: 'Autumn Family'
}, {
  id: 19,
  src: 'https://cdn.magicpatterns.com/uploads/buXkLGkqLRnPCFmJE2ZeRt/617121110_896684032880699_1056563596778329290_n.jpg',
  category: 'Families',
  title: 'Forest Family Fun'
}, {
  id: 26,
  src: 'https://cdn.magicpatterns.com/uploads/ury2hCK9eNtS8vwHYg2ma5/IMG_4976.jpg',
  category: 'Couples',
  title: 'Forehead Touch'
}, {
  id: 31,
  src: 'https://cdn.magicpatterns.com/uploads/uRoAznt6ok71txn3vRK9YQ/FullSizeRender_(5).jpg',
  category: 'Couples',
  title: 'Lakeside Kiss'
}, {
  id: 20,
  src: 'https://cdn.magicpatterns.com/uploads/kdAmFZmnKRXFtpam6MjoCv/633040248_918855943996841_1111303515070654802_n.jpg',
  category: 'Portraits',
  title: 'Birthday Celebration'
}, {
  id: 7,
  src: 'https://cdn.magicpatterns.com/uploads/ah5d5cdpHya7nXSZW9ir4r/583096685_851265814089188_2436431593322140741_n.jpg',
  category: 'Families',
  title: 'Christmas by the Lake'
}, {
  id: 21,
  src: 'https://cdn.magicpatterns.com/uploads/9PdfbxsYu5HdBSS8URu9Vv/634018473_918865153995920_9151874811633063594_n.jpg',
  category: 'Portraits',
  title: 'Little Explorer'
}];
export function Gallery() {
  const [activeCategory, setActiveCategory] = useState<Category>('All');
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const filteredImages = activeCategory === 'All' ? images : images.filter(img => img.category === activeCategory);
  const categories: Category[] = ['All', 'Families', 'Couples', 'Portraits', 'Newborns'];
  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((selectedImageIndex + 1) % filteredImages.length);
    }
  };
  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((selectedImageIndex - 1 + filteredImages.length) % filteredImages.length);
    }
  };
  return <section id="portfolio" className="py-24 bg-white" data-id="element-58">
      <div className="max-w-7xl mx-auto px-6" data-id="element-59">
        <div className="text-center mb-16" data-id="element-60">
          <span className="text-gold text-sm tracking-widest uppercase font-medium mb-4 block" data-id="element-61">
            Portfolio
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-8" data-id="element-62">
            Selected Works
          </h2>

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-63">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`text-sm tracking-wider uppercase transition-colors duration-300 pb-1 border-b-2 ${activeCategory === category ? 'text-charcoal border-gold' : 'text-gray-400 border-transparent hover:text-charcoal'}`} data-id="element-64">
                {category}
              </button>)}
          </div>
        </div>

        {/* Masonry Grid */}
        <motion.div layout className="columns-1 md:columns-2 lg:columns-3 gap-6 [&>*]:mb-6" data-id="element-65">
          <AnimatePresence data-id="element-66">
            {filteredImages.map((image, index) => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4
          }} key={image.id} className="break-inside-avoid relative group cursor-pointer overflow-hidden" onClick={() => setSelectedImageIndex(index)} data-id="element-67">
                <img src={image.src} alt={image.title} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-68" />
                <div className="absolute inset-0 bg-charcoal/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-69">
                  <div className="text-center text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-70">
                    <p className="font-serif text-xl italic mb-1" data-id="element-71">
                      {image.title}
                    </p>
                    <p className="text-xs uppercase tracking-widest opacity-80" data-id="element-72">
                      {image.category}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-73">
        {selectedImageIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4" onClick={() => setSelectedImageIndex(null)} data-id="element-74">
            <button className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors" onClick={() => setSelectedImageIndex(null)} data-id="element-75">
              <X className="w-8 h-8" data-id="element-76" />
            </button>

            <button className="absolute left-4 md:left-8 text-white/50 hover:text-white transition-colors p-2" onClick={handlePrev} data-id="element-77">
              <ChevronLeft className="w-10 h-10" data-id="element-78" />
            </button>

            <div className="max-w-5xl max-h-[85vh] relative" onClick={e => e.stopPropagation()} data-id="element-79">
              <img src={filteredImages[selectedImageIndex].src} alt={filteredImages[selectedImageIndex].title} className="max-w-full max-h-[85vh] object-contain shadow-2xl" data-id="element-80" />
              <div className="absolute -bottom-10 left-0 right-0 text-center text-white/80" data-id="element-81">
                <p className="font-serif text-lg" data-id="element-82">
                  {filteredImages[selectedImageIndex].title}
                </p>
              </div>
            </div>

            <button className="absolute right-4 md:right-8 text-white/50 hover:text-white transition-colors p-2" onClick={handleNext} data-id="element-83">
              <ChevronRight className="w-10 h-10" data-id="element-84" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </section>;
}